module.exports = __webpack_public_path__ + "static/media/moment10.23c89931.webp";